import {
  ROUTE_INCLUDES_ADD,
  ROUTE_INCLUDES_REMOVE
} from './mutation-types'

export default {
  namespaced: true,
  state: {
    cache_includes: [],
  },
  mutations: {
    [ROUTE_INCLUDES_ADD]: (state, module) => {
      const idx = state.cache_includes.indexOf(module.name);
      if (idx == -1) {
        state.cache_includes.push(module.name);
      }
      return state.files;
    },
    [ROUTE_INCLUDES_REMOVE]: (state, module) => {
      const idx = state.cache_includes.indexOf(module.name);
      if (idx != -1) {
        state.cache_includes.splice(idx, 1);
      }
      return state.list;
    }
  },
  actions: {
    add: ({commit, state}, module) => commit(ROUTE_INCLUDES_ADD, module),

    remove: ({commit, state}, module) => commit(ROUTE_INCLUDES_REMOVE, module)
  },
  getters: {
    getRouteCaches: (state) => {
      return state.cache_includes;
    },
  }
}
